import plusHollowCircleFilledComp from "./plus-hollow-circle-filled-comp";
import circleAvatarOutlined from "./circle-avatar-outlined.svg";
import plusCircleFilled from "./plus-circle-filled.svg";
import checkboxInactive from "./checkbox-inactive.svg";
import deleteOutlinedComp from "./delete-outlined-comp";
import editOutlinedComp from "./edit-outlined-comp";
import downOutlinedComp from "./down-outlined-comp";
import checkboxActive from "./checkbox-active.svg";
import thunderCloud from "./thunder-cloud.svg";
import radioActive from "./radio-active.svg";
import balloons404 from "./balloons-404.svg";
import ajaxSmhi from "./ajax-smhi.svg";
import cogWheel from "./cog-wheel.svg";
import balloons from "./balloons.svg";
import devices from "./devices.svg";
import copyComp from "./copy-comp";
import fullLogo from "./full-logo";
import star from "./star";

export default {
  star,
  fullLogo,
  cogWheel,
  devices,
  balloons,
  copyComp,
  ajaxSmhi,
  balloons404,
  radioActive,
  thunderCloud,
  checkboxActive,
  downOutlinedComp,
  checkboxInactive,
  plusCircleFilled,
  editOutlinedComp,
  deleteOutlinedComp,
  circleAvatarOutlined,
  plusHollowCircleFilledComp,
};
